// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"81048430","131":"7763f84f","164":"8f849983","268":"920b66a7","453":"926f0775","588":"e785e44f","709":"667b5058","958":"f8f9e5f9","971":"ea68350f","981":"19074891"}[chunkId] + ".chunk.js";
};